import React from "react";

export default () => {
  return (
    <svg
      width="173px"
      height="143px"
      viewBox="0 0 173 143"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Category C</title>
      <defs>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="cc-linearGradient-1"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M0.0169491525,4.54747351e-13 L28.9526864,4.54747351e-13 L28.9526864,72.3117924 C28.9526864,80.3021756 22.475201,86.779661 14.4848178,86.779661 C6.49443457,86.779661 0.0169491525,80.3021756 0.0169491525,72.3117924 L0.0169491525,4.54747351e-13 L0.0169491525,4.54747351e-13 Z"
          id="cc-path-2"
        ></path>
        <path
          d="M39.0169492,4.54747351e-13 L67.9526864,4.54747351e-13 L67.9526864,72.3117924 C67.9526864,80.3021756 61.475201,86.779661 53.4848178,86.779661 C45.4944346,86.779661 39.0169492,80.3021756 39.0169492,72.3117924 L39.0169492,4.54747351e-13 L39.0169492,4.54747351e-13 Z"
          id="cc-path-3"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="cc-linearGradient-4"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M2,0 L31,0 C32.1045695,-2.02906125e-16 33,0.8954305 33,2 L33,9 C33,10.1045695 32.1045695,11 31,11 L2,11 C0.8954305,11 1.3527075e-16,10.1045695 0,9 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
          id="cc-path-5"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="cc-linearGradient-6"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M130.29835,0 C129.422175,11.8185283 137,13.8029422 137,22.9304552 C137,29.5280382 131.756314,35 123.444672,35 C115.144495,35 110,28.9370623 110,21.5098402 C110,15.3060763 113.072491,9.74714818 118.999502,5.41810199 C118.748328,7.1070279 119.414226,11.2339762 120.720697,12.4806585 C121.96682,3.71781116 128.645043,0.0271769822 130.298399,0 L130.29835,0 Z"
          id="cc-path-7"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="cc-linearGradient-8"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M1,133 L172,133 C172.552285,133 173,133.447715 173,134 L173,141.2 C173,141.752285 172.552285,142.2 172,142.2 L1,142.2 C0.44771525,142.2 6.76353751e-17,141.752285 0,141.2 L0,134 C-6.76353751e-17,133.447715 0.44771525,133 1,133 Z"
          id="cc-path-9"
        ></path>
      </defs>
      <g
        id="cc-Wireframe-v4-Layout-v2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="cc-PWA-Desktop-Page2---Access-Categories---c"
          transform="translate(-881.000000, -565.000000)"
        >
          <g id="cc-cat-C" transform="translate(300.000000, 379.000000)">
            <g id="cc-Group-3" transform="translate(0.000000, 67.000000)">
              <g
                id="cc-category-C"
                transform="translate(581.000000, 119.000000)"
              >
                <path
                  d="M71.3559322,59.4 L71.3559322,44.3761783 C71.3559322,36.0919071 64.6402035,29.3761783 56.3559322,29.3761783 L46.5084746,29.3761783 C38.2242033,29.3761783 31.5084746,36.0919071 31.5084746,44.3761783 L31.5084746,59.4 L31.5084746,59.4"
                  id="cc-Path-7"
                  stroke="#00AEEF"
                  strokeWidth="10"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M71.3559322,59.4 L71.3559322,44.3761783 C71.3559322,36.0919071 64.6402035,29.3761783 56.3559322,29.3761783 L46.5084746,29.3761783 C38.2242033,29.3761783 31.5084746,36.0919071 31.5084746,44.3761783 L31.5084746,59.4 L31.5084746,59.4"
                  id="cc-Path-7-Copy-2"
                  stroke="#79D4F6"
                  strokeWidth="12"
                  strokeLinejoin="round"
                  strokeDasharray="1.69"
                ></path>
                <polyline
                  id="cc-Path"
                  stroke="#00AEEF"
                  strokeWidth="3"
                  strokeLinejoin="round"
                  points="149.804831 139.287541 149.804831 124.963078 135.435169 57.5660652 135.435169 55.278002 135.435169 39 112.369661 39.0100847 112.369661 55.2811519 112.369661 57.5739208 98 124.96435 98 139.287541 149.482851 125.287541 102 109.268373 144 97.5 106.369661 86.5 138.435169 73 111.369661 64.8047615 135.284234 57.5739208 112.77979 48.5430034"
                ></polyline>
                <g
                  id="cc-Group-4-Copy"
                  transform="translate(16.983051, 52.000000)"
                >
                  <g
                    id="cc-Rectangle-Copy-20"
                    transform="translate(14.484818, 43.389831) scale(1, -1) translate(-14.484818, -43.389831) "
                  >
                    <use fill="#8FD5EF" href="#cc-path-2"></use>
                    <use
                      fill="url(#cc-linearGradient-1)"
                      style={{ mixBlendMode: "screen" }}
                      href="#cc-path-2"
                    ></use>
                  </g>
                  <g
                    id="cc-Rectangle-Copy-44"
                    transform="translate(53.484818, 43.389831) scale(1, -1) translate(-53.484818, -43.389831) "
                  >
                    <use fill="#8FD5EF" href="#cc-path-3"></use>
                    <use
                      fill="url(#cc-linearGradient-1)"
                      style={{ mixBlendMode: "screen" }}
                      href="#cc-path-3"
                    ></use>
                  </g>
                </g>
                <g
                  id="cc-Group-4-Copy-3"
                  transform="translate(107.000000, 40.000000)"
                >
                  <g
                    id="cc-Rectangle-Copy-20"
                    transform="translate(16.500000, 5.500000) scale(1, -1) translate(-16.500000, -5.500000) "
                  >
                    <use fill="#8FD5EF" href="#cc-path-5"></use>
                    <use
                      fill="url(#cc-linearGradient-4)"
                      style={{ mixBlendMode: "screen" }}
                      href="#cc-path-5"
                    ></use>
                  </g>
                </g>
                <g id="cc-Fill-1">
                  <use fill="#487FB4" href="#cc-path-7"></use>
                  <use
                    fillOpacity="0.5"
                    fill="url(#cc-linearGradient-6)"
                    style={{ mixBlendMode: "multiply" }}
                    href="#path-7"
                  ></use>
                </g>
                <g
                  id="cc-Rectangle-Copy-37"
                  transform="translate(86.499998, 137.600000) scale(1, -1) translate(-86.499998, -137.600000) "
                >
                  <use fill="#00AEEF" href="#cc-path-9"></use>
                  <use
                    fill="url(#cc-linearGradient-8)"
                    style={{ mixBlendMode: "screen" }}
                    href="#path-9"
                  ></use>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
